import { useQuery } from '@apollo/client';
import { useAuth } from '@contexts/AuthContext';
import { useProId } from '@contexts/ProIdContext';
import { GET_FILES_BY_TALENT, GET_FILES_BY_TALENT_UPERCUT } from '@gql/file';

export const useFileForTalent = (
    talentId: string,
    context: string,
    limit: number,
    offset: number,
    search?: string
) => {
    const { user, isUpercut } = useAuth();
    const { isProIdRequired } = useProId();

    const isUpercutFlow = isUpercut && !isProIdRequired;
    const queryToUse = isUpercutFlow ? GET_FILES_BY_TALENT_UPERCUT : GET_FILES_BY_TALENT;

    const { data, loading, fetchMore, refetch, error } = useQuery(queryToUse, {
        variables: {
            talentId,
            context,
            limit,
            offset,
            search,
        },
        notifyOnNetworkStatusChange: true,
        skip: !user,
    });

    const filesConnection = isUpercutFlow ? data?.getFilesByTalentUpercut : data?.getFilesByTalent;

    return {
        data,
        loading,
        fetchMore,
        refetch,
        error,
        files: filesConnection?.files || [],
        total: filesConnection?.total || 0,
        hasMore: filesConnection?.hasMore || false,
        filesQueryName: isUpercutFlow ? 'GetFilesByTalentUpercut' : 'GetFilesByTalent',
        filesCountQueryName: isUpercutFlow ? 'GetFilesCountByTalentsUpercut' : 'GetFilesCountByTalents',
        isUpercutFlow,
    };
};
